import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import * as pdfjsLib from 'pdfjs-dist';
import mammoth from 'mammoth';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Button, Box, Grid, Typography } from '@mui/material';
import { API_BASE_URL, Heading_Text_Color } from '../../constant/constant';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const DocumentUploader = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [scale, setScale] = useState(1.5);
  const [uploadProgress, setUploadProgress] = useState({});

  const onDrop = (acceptedFiles) => {
    setSelectedFiles(acceptedFiles);

    acceptedFiles.forEach((file) => {
      if (file.type === 'application/pdf') {
        const reader = new FileReader();
        reader.onload = async () => {
          const typedArray = new Uint8Array(reader.result);
          const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise;
          const pagePreviews = [];

          for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
            const page = await pdf.getPage(pageNum);
            const viewport = page.getViewport({ scale });
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            await page.render({ canvasContext: context, viewport }).promise;
            const dataUrl = canvas.toDataURL();
            pagePreviews.push({ pageNum, dataUrl });
          }

          setPreviews((prev) => [
            ...prev,
            {
              file,
              type: 'pdf',
              pages: pagePreviews,
            },
          ]);
        };
        reader.readAsArrayBuffer(file);
      } else if (
        file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.type === 'application/msword'
      ) {
        const reader = new FileReader();
        reader.onload = async () => {
          const result = await mammoth.convertToHtml({ arrayBuffer: reader.result });
          setPreviews((prev) => [
            ...prev,
            {
              file,
              type: 'docx',
              content: result.value,
            },
          ]);
        };
        reader.readAsArrayBuffer(file);
      } else if (file.type === 'text/plain') {
        const reader = new FileReader();
        reader.onload = () => {
          const textContent = reader.result;
          const htmlContent = `<pre style="white-space: pre-wrap; word-wrap: break-word;">${textContent}</pre>`;
          setPreviews((prev) => [
            ...prev,
            {
              file,
              type: 'txt',
              content: htmlContent,
            },
          ]);
        };
        reader.readAsText(file);
      }
    });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    accept: {
      'application/pdf': ['.pdf'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      'application/msword': ['.doc'],
      'text/plain': ['.txt'],
    },
  });

  const handlePrint = (preview) => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    if (preview.type === 'pdf') {
      preview.pages.forEach((page) => {
        printWindow.document.write(`<img src="${page.dataUrl}" style="width:100%; margin-bottom: 20px;" />`);
      });
    } else {
      printWindow.document.write(preview.content);
    }
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => printWindow.print(), 500);
  };

  const handleUpload = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      const xhr = new XMLHttpRequest();
     // xhr.open('POST', `${API_BASE_URL}/upload.php`);
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setUploadProgress((prev) => ({ ...prev, [file.name]: percent }));
        }
      };
      xhr.onload = () => {
        alert(`${file.name} uploaded successfully.`);
        setUploadProgress((prev) => ({ ...prev, [file.name]: 100 }));
      };
      xhr.onerror = () => {
        alert(`${file.name} upload failed.`);
      };
      xhr.send(formData);
    } catch (err) {
      alert('Upload failed: ' + err.message);
    }
  };

  const handleRefresh = () => {
    setSelectedFiles([]);
    setPreviews([]);
    setUploadProgress({});
  };

  const handleMergeAndSave = async () => {
    const pdf = new jsPDF();

    for (let i = 0; i < previews.length; i++) {
      const preview = previews[i];

      if (preview.type === 'pdf') {
        for (let j = 0; j < preview.pages.length; j++) {
          const page = preview.pages[j];
          const img = new Image();
          img.src = page.dataUrl;

          await new Promise((resolve) => {
            img.onload = () => {
              const width = pdf.internal.pageSize.getWidth();
              const height = (img.height * width) / img.width;
              if (i !== 0 || j !== 0) pdf.addPage();
              pdf.addImage(img, 'PNG', 0, 0, width, height);
              resolve();
            };
          });
        }
      } else if (preview.type === 'docx' || preview.type === 'txt') {
        const div = document.createElement('div');
        div.innerHTML = preview.content;
        div.style.padding = '20px';
        div.style.maxWidth = '800px';
        div.style.backgroundColor = 'white';
        document.body.appendChild(div);

        await html2canvas(div, { scale: 2 }).then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const width = pdf.internal.pageSize.getWidth();
          const height = (canvas.height * width) / canvas.width;
          if (i !== 0) pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, 0, width, height);
        });

        document.body.removeChild(div);
      }
    }

    pdf.save('merged_documents.pdf');
  };

  return (
    <div>

  <Grid container alignItems="center" justifyContent="space-between" style={{ marginBottom: 16 }}>
  {/* <Grid>
    <h2 gutterBottom style={{ color: Heading_Text_Color, textAlign: 'center' }}>📁 Documents Files Explorer</h2>
  </Grid> */}
  



   <Typography gutterBottom style={{ color: Heading_Text_Color,  fontSize: '1.25rem'   }}>
📁 Documents Files Explorer
             </Typography>
</Grid>



      {/* Control Buttons */}
     
      {previews.length > 0 && (
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
  <Button 
    variant="contained" 
    color="secondary" 
    onClick={handleMergeAndSave}
    startIcon={<span>📄</span>}
  >
    Merge & Save All as PDF
  </Button>

  <Button 
    variant="contained" 
    color="primary" 
    onClick={handleRefresh}
    startIcon={<span>🔄</span>}
  >
    Refresh
  </Button>

 
</Box>
)}
  

      {/* Dropzone */}
      <div
        {...getRootProps()}
        style={{
          border: '2px dashed #007bff',
          padding: 40,
          borderRadius: 10,
          backgroundColor: isDragActive ? '#e6f0ff' : '#f9f9f9',
          textAlign: 'center',
          cursor: 'pointer',
          marginBottom: 20,
        }}
      >
        <input {...getInputProps()} />
        <p>{isDragActive ? 'Drop files here...' : 'Drag & drop DOCX/PDF/TXT or click to browse'}</p>
        <em>Accepted formats: .doc, .docx, .pdf, .txt</em>
      </div>

      {/* File Previews */}
      {previews.map((preview, index) => (
        <div key={index} style={{ marginBottom: 40, textAlign: 'center' }}>
          <strong>{preview.file.name}</strong>

          {preview.type === 'pdf' ? (
            <div style={{ marginTop: 10 }}>
              <div style={{ marginBottom: 10 }}>
                <button onClick={() => setScale((prev) => prev + 0.25)}>➕ Zoom In</button>
                <button onClick={() => setScale((prev) => Math.max(0.5, prev - 0.25))}>➖ Zoom Out</button>
              </div>

              {preview.pages.map((page) => (
                <div key={page.pageNum} style={{ marginBottom: 20 }}>
                  <div>Page {page.pageNum}</div>
                  <img
                    src={page.dataUrl}
                    alt={`Page ${page.pageNum}`}
                    style={{
                      transform: `scale(${scale})`,
                      transformOrigin: 'top center',
                      border: '1px solid #ccc',
                      marginTop: 5,
                    }}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                textAlign: 'left',
                padding: 20,
                border: '1px solid #ccc',
                backgroundColor: '#f9f9f9',
                maxWidth: 800,
                margin: '20px auto',
              }}
              dangerouslySetInnerHTML={{ __html: preview.content }}
            />
          )}

          <div style={{ marginTop: 10 }}>
            <button onClick={() => handlePrint(preview)} style={{ marginRight: 10 }}>🖨️ Print</button>
            <button onClick={() => handleUpload(preview.file)}>⬆️ Upload</button>
          </div>

          {uploadProgress[preview.file.name] !== undefined && (
            <div style={{ marginTop: 10 }}>
              <progress value={uploadProgress[preview.file.name]} max="100" />
              <span style={{ marginLeft: 10 }}>{uploadProgress[preview.file.name]}%</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default DocumentUploader;
